export default function auth({
    next,
    router
}) {
    if (localStorage.getItem('sw_status') >= 3 || localStorage.getItem('sw_status') < 0) return router.push({
        name: 'home'
    });

    return next();
}